import { PricelistService } from '../../../configuration/pricelist/models/pricelist.model';
import { IProviderList } from '../../../provider/models/provider.model';

export interface IContract {
  insuranceCompanyId: string;
  insuranceCompanyNameArabic: string,
  insuranceCompanyNameEnglish: string,
  contractId: string;
  priceIds: string[];
  priceListDetails: PriceList[];
  contractStatusNameEnglish: string;
  contractStatusNameArabic: string;
  contractStatusId: string;
  createdBy: string;
  createdDate: string;
  deleted: boolean;
  deletedBy: string;
  deletedDate: string;
  directDiscountsConsultation: number;
  directDiscountsMedicalService: number;
  directDiscountsMedicines: number;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  nameArabic: string;
  nameEnglish: string;
  ppdNetClaimedAmountForDiscount: string;
  ppdSecondPartyOfferDiscount: string;
  providerId: string;
  specialCondition: string;
  validFrom: string;
  validTo: string;
  versionNo: number;
  contractProviderDetails: IProviderList;
  contractBusinessVolumeDetails: ContractBusinessVolumeDiscount[];
  erpContractId?: string;
}

export interface PriceList {
  priceListId: string;
  insuranceCompanyId: string;
  insuranceCompanyNameEnglish: string;
  insuranceCompanyNameArabic: string;
  effectiveDate: string;
  deleted: boolean;
  createdBy: string;
  createdDate: string;
  lastUpdatedBy: string;
  lastUpdatedDate: string;
  deletedBy?: string;
  deletedDate?: string;
  priceListServices?: PricelistService[];
}

export interface IInsuranceCompany {
  companyId: string;
  nameEnglish: string;
  nameArabic: string;
}

export interface IProvider {
  providerId: string;
  nameEnglish: string;
  nameArabic: string;
}

export interface ContractBusinessVolumeDiscount {
  contractBusinessVolumeDiscountId?: string,
  contractId?: string,
  businessVolume: string,
  discount: string
}

export const contractConfig = {
  entityName: 'CONTRACT.TITLE',
  nameEnglish: 'CONTRACT.NAME_ENGLISH',
  nameArabic: 'CONTRACT.NAME_ARABIC',
  versionNo: 'FORM_FIELD.VERSION_NUMBER',
  validFrom: 'COMMON.VALIDATE_FROM',
  validTo: 'COMMON.VALIDATE_TO',
  createdDate: 'FORM_FIELD.CREATED_DATE',
  providerId: 'PROVIDER.TITLE',
  networkIds: 'CONFIGURATION.NETWORK.CONTRACT',
  priceIds: 'CONTRACT.PRICES',
  contractStatusId: 'CONTRACT.STATUS',
  companyId: 'INSURANCE_COMPANY.TITLE',
  specialCondition: 'FORM_FIELD.SPECIAL_CONDITION',
  directDiscountsConsultation: 'FORM_FIELD.CONSULTATION',
  directDiscountsMedicalService: 'CONFIGURATION.MEDICAL_DEVICE.SERVICE',
  directDiscountsMedicines: 'CONFIGURATION.MEDICAL_DEVICE.MEDICINES',
  bvdBusinessVolumeInSar: 'FORM_FIELD.BUSINESS_VOLUME_(IN SAR)',
  ppdNetClaimedAmountForDiscount: 'FORM_FIELD.NET_CLAIMED_AMOUNT_(FOR DISCOUNT)',
  ppdSecondPartyOfferDiscount: 'FORM_FIELD.DISCOUNTS_OFFER_BY_SECOND_PARTY',
  bvdDiscount: 'FORM_FIELD.DISCOUNT_AS_PERCENTAGE',
  editBusinessVolume: 'CONTRACT.EDIT_BVD',
  addBusinessVolume: 'CONTRACT.ADD_BVD',
};